/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _feed_post_reaction_user_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                '=0': {
                    value: [
                        { type: 0, value: '<b>' },
                        { type: 1, value: 'userName' },
                        { type: 0, value: '</b> a réagi à votre post' },
                    ],
                },
                '=1': {
                    value: [
                        { type: 0, value: '<b>' },
                        { type: 1, value: 'userName' },
                        {
                            type: 0,
                            value: '</b> et une autre personne ont réagi à votre post',
                        },
                    ],
                },
                other: {
                    value: [
                        { type: 0, value: '<b>' },
                        { type: 1, value: 'userName' },
                        { type: 0, value: '</b> et ' },
                        { type: 7 },
                        { type: 0, value: ' autres personnes ont réagi à votre post' },
                    ],
                },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

export function feed_post_reaction_user(
    args: { count: number; userName: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _feed_post_reaction_user_fr.format(args) as unknown as string;
    }

    return _feed_post_reaction_user_fr.format(args) as unknown as string;
}

const _feed_post_reaction_company_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                '=0': {
                    value: [
                        { type: 0, value: '<b>' },
                        { type: 1, value: 'userName' },
                        { type: 0, value: '</b> a réagi au post de votre société <b>' },
                        { type: 1, value: 'companyName' },
                        { type: 0, value: '</b>' },
                    ],
                },
                '=1': {
                    value: [
                        { type: 0, value: '<b>' },
                        { type: 1, value: 'userName' },
                        {
                            type: 0,
                            value: '</b> et une autre personne ont réagi au post de votre société <b>',
                        },
                        { type: 1, value: 'companyName' },
                        { type: 0, value: '</b>' },
                    ],
                },
                other: {
                    value: [
                        { type: 0, value: '<b>' },
                        { type: 1, value: 'userName' },
                        { type: 0, value: '</b> et ' },
                        { type: 7 },
                        {
                            type: 0,
                            value: ' autres personnes ont réagi au post de votre société <b>',
                        },
                        { type: 1, value: 'companyName' },
                        { type: 0, value: '</b>' },
                    ],
                },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

export function feed_post_reaction_company(
    args: { count: number; userName: string; companyName: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _feed_post_reaction_company_fr.format(args) as unknown as string;
    }

    return _feed_post_reaction_company_fr.format(args) as unknown as string;
}

const _feed_post_share_user_fr = new IntlMessageFormat(
    [
        { type: 0, value: '<b>' },
        { type: 1, value: 'userName' },
        { type: 0, value: '</b> a partagé votre post' },
    ],
    'fr',
);

export function feed_post_share_user(args: { userName: string }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _feed_post_share_user_fr.format(args) as unknown as string;
    }

    return _feed_post_share_user_fr.format(args) as unknown as string;
}

const _feed_post_share_company_fr = new IntlMessageFormat(
    [
        { type: 0, value: '<b>' },
        { type: 1, value: 'userName' },
        { type: 0, value: '</b> a partagé le post de votre société <b>' },
        { type: 1, value: 'companyName' },
        { type: 0, value: '</b>' },
    ],
    'fr',
);

export function feed_post_share_company(
    args: { userName: string; companyName: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _feed_post_share_company_fr.format(args) as unknown as string;
    }

    return _feed_post_share_company_fr.format(args) as unknown as string;
}

const _feed_post_comment_user_fr = new IntlMessageFormat(
    [
        { type: 0, value: '<b>' },
        { type: 1, value: 'userName' },
        { type: 0, value: '</b> a commenté votre post:<br/><small><i>' },
        { type: 1, value: 'text' },
        { type: 0, value: '</i></small>' },
    ],
    'fr',
);

export function feed_post_comment_user(
    args: { userName: string; text: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _feed_post_comment_user_fr.format(args) as unknown as string;
    }

    return _feed_post_comment_user_fr.format(args) as unknown as string;
}

const _feed_post_comment_company_fr = new IntlMessageFormat(
    [
        { type: 0, value: '<b>' },
        { type: 1, value: 'userName' },
        { type: 0, value: '</b> a commenté le post de votre société <b>' },
        { type: 1, value: 'companyName' },
        { type: 0, value: '</b>:<br/><small><i>' },
        { type: 1, value: 'text' },
        { type: 0, value: '</i></small>' },
    ],
    'fr',
);

export function feed_post_comment_company(
    args: { userName: string; companyName: string; text: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _feed_post_comment_company_fr.format(args) as unknown as string;
    }

    return _feed_post_comment_company_fr.format(args) as unknown as string;
}

const _feed_post_comment_reply_user_fr = new IntlMessageFormat(
    [
        { type: 0, value: '<b>' },
        { type: 1, value: 'userName' },
        { type: 0, value: '</b> a répondu à votre commentaire:<br/><small><i>' },
        { type: 1, value: 'text' },
        { type: 0, value: '</i></small>' },
    ],
    'fr',
);

export function feed_post_comment_reply_user(
    args: { userName: string; text: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _feed_post_comment_reply_user_fr.format(args) as unknown as string;
    }

    return _feed_post_comment_reply_user_fr.format(args) as unknown as string;
}

const _feed_post_comment_reply_company_fr = new IntlMessageFormat(
    [
        { type: 0, value: '<b>' },
        { type: 1, value: 'userName' },
        { type: 0, value: '</b> a répondu au commentaire de votre société société <b>' },
        { type: 1, value: 'companyName' },
        { type: 0, value: '</b>:<br/><small><i>' },
        { type: 1, value: 'text' },
        { type: 0, value: '</i></small>' },
    ],
    'fr',
);

export function feed_post_comment_reply_company(
    args: { userName: string; companyName: string; text: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _feed_post_comment_reply_company_fr.format(args) as unknown as string;
    }

    return _feed_post_comment_reply_company_fr.format(args) as unknown as string;
}

const _feed_post_comment_mention_user_fr = new IntlMessageFormat(
    [
        { type: 0, value: '<b>' },
        { type: 1, value: 'userName' },
        { type: 0, value: '</b> vous a mentionné dans un commentaire:<br/><small><i>' },
        { type: 1, value: 'text' },
        { type: 0, value: '</i></small>' },
    ],
    'fr',
);

export function feed_post_comment_mention_user(
    args: { userName: string; text: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _feed_post_comment_mention_user_fr.format(args) as unknown as string;
    }

    return _feed_post_comment_mention_user_fr.format(args) as unknown as string;
}

const _feed_post_comment_mention_company_fr = new IntlMessageFormat(
    [
        { type: 0, value: '<b>' },
        { type: 1, value: 'userName' },
        { type: 0, value: '</b> a mentionné votre société <b>' },
        { type: 1, value: 'companyName' },
        { type: 0, value: '</b> dans un commentaire:<br/><small><i>' },
        { type: 1, value: 'text' },
        { type: 0, value: '</i></small>' },
    ],
    'fr',
);

export function feed_post_comment_mention_company(
    args: { userName: string; companyName: string; text: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _feed_post_comment_mention_company_fr.format(args) as unknown as string;
    }

    return _feed_post_comment_mention_company_fr.format(args) as unknown as string;
}

const _new_follower_user_fr = new IntlMessageFormat(
    [
        { type: 0, value: '<b>' },
        { type: 1, value: 'userName' },
        { type: 0, value: '</b> a commencé à vous suivre' },
    ],
    'fr',
);

export function new_follower_user(args: { userName: string }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _new_follower_user_fr.format(args) as unknown as string;
    }

    return _new_follower_user_fr.format(args) as unknown as string;
}

const _new_follower_company_fr = new IntlMessageFormat(
    [
        { type: 0, value: '<b>' },
        { type: 1, value: 'userName' },
        { type: 0, value: '</b> a commencé à suivre votre société <b>' },
        { type: 1, value: 'companyName' },
        { type: 0, value: '</b>' },
    ],
    'fr',
);

export function new_follower_company(
    args: { userName: string; companyName: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _new_follower_company_fr.format(args) as unknown as string;
    }

    return _new_follower_company_fr.format(args) as unknown as string;
}
